import { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { useToast, useTranslator, useAppContext } from '@front-activerse/common-components';

const DayPlanMealRating = ({ meal, rateMeal, refetch, reference }) => {
  const { t } = useTranslator();
  const { toastSuccess, toastError } = useToast();

  const [showRatingModal, setShowRatingModal] = useState(false);

  const convertRatingLabelsFromApi = (labels) => {
    return labels.map((label) => label.name);
  };

  const [rating, setRating] = useState(meal.rating.userRating ? meal.rating.userRating.rating : 0);
  const [ratingLabels, setRatingLabels] = useState(
    meal.rating.userRating ? convertRatingLabelsFromApi(meal.rating.userRating.labels) : []
  );

  const {
    images: {
      ratingStarEmpty,
      ratingStarHalf,
      ratingStarFull,
      ratingStarPopupEmpty,
      ratingStarPopupFull,
    },
  } = useAppContext();

  useEffect(() => {
    setRating(meal.rating.userRating ? meal.rating.userRating.rating : 0);
    setRatingLabels(
      meal.rating.userRating ? convertRatingLabelsFromApi(meal.rating.userRating.labels) : []
    );
  }, [meal.rating.userRating]);

  const renderMealRating = () => {
    if (meal.rating.averageRating) {
      const rating = meal.rating.averageRating.averageRating;
      let stars = [];
      if (1 <= rating && rating <= 1.2) {
        stars = [
          ratingStarFull,
          ratingStarEmpty,
          ratingStarEmpty,
          ratingStarEmpty,
          ratingStarEmpty,
        ];
      } else if (1.2 < rating && rating <= 1.7) {
        stars = [ratingStarFull, ratingStarHalf, ratingStarEmpty, ratingStarEmpty, ratingStarEmpty];
      } else if (1.7 < rating && rating <= 2.2) {
        stars = [ratingStarFull, ratingStarFull, ratingStarEmpty, ratingStarEmpty, ratingStarEmpty];
      } else if (2.2 < rating && rating <= 2.7) {
        stars = [ratingStarFull, ratingStarFull, ratingStarHalf, ratingStarEmpty, ratingStarEmpty];
      } else if (2.7 < rating && rating <= 3.2) {
        stars = [ratingStarFull, ratingStarFull, ratingStarFull, ratingStarEmpty, ratingStarEmpty];
      } else if (3.2 < rating && rating <= 3.7) {
        stars = [ratingStarFull, ratingStarFull, ratingStarFull, ratingStarHalf, ratingStarEmpty];
      } else if (3.7 < rating && rating <= 4.2) {
        stars = [ratingStarFull, ratingStarFull, ratingStarFull, ratingStarFull, ratingStarEmpty];
      } else if (4.2 < rating && rating <= 4.7) {
        stars = [ratingStarFull, ratingStarFull, ratingStarFull, ratingStarFull, ratingStarHalf];
      } else if (4.7 < rating && rating <= 5) {
        stars = [ratingStarFull, ratingStarFull, ratingStarFull, ratingStarFull, ratingStarFull];
      }

      return (
        <div className="rating">
          {stars.map((star) => (
            <img src={star} alt="" />
          ))}
          <span className="ms-1">({meal.rating.averageRating.ratingsCount})</span>
        </div>
      );
    } else {
      return <span>{t('mealDetails.info.rating.addFirstRate.info')}</span>;
    }
  };

  const toggleRatingModal = () => {
    setShowRatingModal(!showRatingModal);
  };

  const toggleRatingTag = (label) => {
    if (ratingLabels.includes(label)) {
      setRatingLabels(ratingLabels.filter((item) => item !== label));
    } else {
      setRatingLabels([...ratingLabels, label]);
    }
  };

  const handleRateMeal = async () => {
    const request = { mealId: meal.id, rating, labels: ratingLabels };
    const response = await rateMeal(request);

    if (response.data.me.dietMealRating.rateItem.__typename === 'BasicMutationSuccess') {
      toastSuccess(<p className="mb-0">{t('meal.notification.addedRate.content')}</p>);
      refetch();
      toggleRatingModal();
    } else {
      toastError(<p className="mb-0">{t('meal.notification.errorRate.content')}</p>);
    }
  };

  return (
    <>
      <div
        className="grey-box mb-2 cursor-pointer d-flex align-items-center justify-content-between"
        ref={reference}
        onClick={toggleRatingModal}
      >
        {t('mealDetails.info.rating.title')}
        {renderMealRating()}
      </div>

      <Modal
        isOpen={showRatingModal}
        toggle={toggleRatingModal}
        size="md"
        centered
        className="rating-modal"
      >
        <ModalBody>
          <h4 className="title-medium semi-bold mb-l">{t('meal.addRatePopup.title')}</h4>
          {[1, 2, 3, 4, 5].map((value) => (
            <img
              key={value}
              src={rating < value ? ratingStarPopupEmpty : ratingStarPopupFull}
              alt=""
              className="rating-star"
              onClick={() => setRating(value)}
            />
          ))}

          {rating > 0 && (
            <div className="mt-xxl">
              <p className="mb-xl">{t('meal.addRatePopup.content')}</p>
              <div className="tags">
                {meal.rating.availableLabels.map((label) => (
                  <span
                    className={ratingLabels.includes(label.name) ? 'tag active' : 'tag'}
                    onClick={() => toggleRatingTag(label.name)}
                  >
                    {label.name}
                  </span>
                ))}
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            className="w-100"
            onClick={() => handleRateMeal()}
            disabled={rating === 0}
          >
            {t('meal.addRatePopup.saveButton')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DayPlanMealRating;
